import React from 'react';

import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { cardsDataQueryKey, listCardsDataQueryKey } from 'api/queries/getListFilteredCards.query';

import { MainCardRoutingModal } from 'components/common/MainCardRoutingModal/mainCardRoutingModal';

import ColumnsBoard from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/ColumnsBoard/ColumnsBoard';
import { MobilePageContainer } from 'components/Mobile/components/PageContainer/pageContainer.mobile';
import { mobileAppConfig } from 'components/Mobile/mobileConfig';
import classes from 'components/Mobile/pages/activities/activities.mobile.module.scss';

export const ActivitiesMobile = () => {
    useFullStoryPageView({ pageName: `${mobileAppConfig.activities.title} (mobile)` });
    return (
        <MobilePageContainer className={classes.columnsBoardLayout}>
            <ColumnsBoard />
            <MainCardRoutingModal queryKeys={[cardsDataQueryKey, listCardsDataQueryKey, 'CountersData', 'boardInit']} />
        </MobilePageContainer>
    );
};
